import { useState } from "react";
import { ChevronRight, ChevronDown, Wrench } from "lucide-react";

export interface ToolCall {
  id: string;
  name: string;
  /** Legacy field used by ChatPanel / types.ts */
  input?: unknown;
  /** Legacy field used by ChatPanel / types.ts */
  output?: unknown;
  /** Alias for input — accepted by new tests */
  args?: Record<string, unknown>;
  /** Alias for output — accepted by new tests */
  result?: unknown;
  verdict?: "allow" | "ask" | "deny";
  ts?: number;
  durationMs?: number;
}

interface Props {
  call: ToolCall;
}

export function ToolCallCard({ call }: Props) {
  const [expanded, setExpanded] = useState(false);

  const inputData = call.args ?? call.input;
  const outputData = call.result ?? call.output;

  return (
    <div className="tool-call-chip" data-testid="tool-call-chip">
      <button
        type="button"
        className="tool-call-chip__row"
        onClick={() => setExpanded((v) => !v)}
        aria-expanded={expanded}
        aria-label={call.name}
      >
        <span className="tool-call-card__chevron">
          {expanded ? <ChevronDown size={12} /> : <ChevronRight size={12} />}
        </span>
        <Wrench size={12} className="tool-call-card__icon" />
        <span className="tool-call-chip__name">{call.name}</span>
        {call.verdict && (
          <span role="status" className={`tool-call-card__verdict verdict--${call.verdict}`}>
            {call.verdict}
          </span>
        )}
        {call.durationMs !== undefined && (
          <span className="tool-call-chip__meta">· {call.durationMs} ms</span>
        )}
      </button>

      {expanded && (
        <div className="tool-call-chip__body">
          {inputData !== undefined && (
            <pre className="tool-call-chip__args">
              {typeof inputData === "string" ? inputData : JSON.stringify(inputData, null, 2)}
            </pre>
          )}
          {outputData !== undefined && (
            <pre className="tool-call-chip__result">
              {typeof outputData === "string" ? outputData : JSON.stringify(outputData, null, 2)}
            </pre>
          )}
        </div>
      )}
    </div>
  );
}
